import { FormularioInformeDividendoNoRecaudadoModel } from "../models/formularioInformeDividendoNoRecaudadoModel";
import { FormularioInformeDividendoRecaudadoModel } from "../models/formularioInformeDividendoRecaudadoModel";
import { generarReporteDividendoRecaudacion, generarReporteDividendoNoRecaudacion } from "../services/reporteDividendoRecaudacionService";

export function UseReporteDividendoRecaudacion(){

    const generarReporteRecaudados = async (e:FormularioInformeDividendoRecaudadoModel | FormularioInformeDividendoNoRecaudadoModel, recaudados: boolean = true) => {
        return recaudados ? await generarReporteDividendoRecaudacion(e as FormularioInformeDividendoRecaudadoModel) : await generarReporteDividendoNoRecaudacion(e as FormularioInformeDividendoNoRecaudadoModel);
    }

    return {
        generarReporteRecaudados
    }
}